<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="full-screen"
      not-footer-padding
      style="position: relative"
      :visible.sync="modalVisible">
    <template #header>
      <span>分单</span>
    </template>
    <template #content>
      <div class="loading-wrapper" v-show="loading.content" v-loading="loading.content"></div>
      <div v-for="(order,index) in tableData" :key="index" :class="{'table-content' : true,'m-top': index === 0}">
        <!-- 顶部通栏  -->
<!--        <div class="info-box-out">-->
          <div class="info-box align-center">

            <span class="gj-tag" v-if="order.urgent">急</span>
            <div class="gj-label-img">
              <gj-image :src="order.smallImageUrl" v-if="order.purchaseType === 'split'"></gj-image>
            </div>

            <div class="gj-label-str ellipsis" style="width: 170px;">
              <gj-tooltip :text-line="1" :content="order.sku">SKU：
                <span class="gj-text">{{ order.sku }}</span></gj-tooltip>
            </div>

            <div class="gj-label-str ellipsis" style="width: 171px;">
              <gj-tooltip :text-line="1" :content="order.productName">产品名称：
                <span class="gj-text">{{ order.productName }}</span></gj-tooltip>
            </div>

            <div class="gj-label-str ">
              计划交期：<span class="gj-text">{{ order.planDeliveryDate }}</span>
            </div>

            <div class="gj-label-str ellipsis" style="width: 123px;">
              <gj-tooltip :text-line="1" :content="order.deliveryWarehouseName">
                目的仓：<span class="gj-text">{{ order.deliveryWarehouseName }}</span></gj-tooltip>
            </div>

            <div class="gj-label-str ellipsis" style="width: 184px;" v-if="order.productType === 'Assembly'">
              <gj-tooltip :text-line="1" :content="order.assembly">
                组合规则：<span class="gj-text">{{ order.assembly }}</span></gj-tooltip>
            </div>

            <div class="gj-label-str ">
              需求量：<span class="gj-text">{{ order.planQuantity }}</span>
            </div>

            <div class="gj-label-str " v-if="order.purchaseType === 'single' ">
              已分单量：<span :class="{'gj-text':true, 'error-tips':order.errorTips}">{{ order.sumSingleQuantity }}</span>
            </div>

            <el-radio-group v-model="order.purchaseType" @change="changePurchaseType(order.purchaseType,order)" v-if="order.productType === 'Assembly'">
              <el-radio label="single">单采</el-radio>
              <el-radio label="split">分采</el-radio>
            </el-radio-group>

          </div>
        <div>
          <op-purchase-plan-order-table
              ref='orderTable'
              :form="order"
              :open-validate="openValid"
              :mount-to="$mountTo">
          </op-purchase-plan-order-table>
        </div>
      </div>
    </template>
    <template #footer>
      <gj-button @click="cancel">取消</gj-button>
      <gj-button @click="subOrder" :loading="loading.subOrder" type="primary">生成采购订单
      </gj-button>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn, formRuleMixin, responseMixin, opTypeMixin, valueCheckMixin} from "@/minxins";
import OpPurchasePlanOrderTable from './product/op-purchase-plan-order-table'
import {purchasePlanSplitOrder, purchasePlanGenerateOrder, purchasePlanQuerySupplier} from '@/api/purchase'

export default {
  name: "op-purchase-plan-create-order",
  mixins: [modalMixIn, formRuleMixin, responseMixin, opTypeMixin, valueCheckMixin],
  components: {OpPurchasePlanOrderTable},
  props: {
    rows: {
      required: true
    }
  },
  data() {
    return {
      loading: {
        content: true,
        subOrder: false,
      },
      fdList: [],
      tableData: [],
      openValid: false,
    }
  },
  created() {
    this.$gjQuery(this.rows, 'single');
  },
  watch: {
    'tableData': {
      handler() {
        this.tableData.forEach(item => {
          if (item.purchaseType === 'single') {  // 单采
            let sumSingleQuantity = 0;
            item.childProductVOList[0]?.planSupplierInfoVOList.forEach(sup => {
              if (sup.splitOrderQuantity){
                sumSingleQuantity += Number(sup.splitOrderQuantity)
              }
            })
            item.sumSingleQuantity = sumSingleQuantity;
            if(item.sumSingleQuantity){
              item.errorTips = item.planQuantity !== item.sumSingleQuantity;
            }
          } else {
            item.childProductVOList.forEach(child => {
              let sumSplit = 0;
              child.planSupplierInfoVOList.forEach(sup => {
                if (sup.splitOrderQuantity){
                  sumSplit += Number(sup.splitOrderQuantity);
                }
              })
              child.sumSplitQuantity = sumSplit;
              if(child.sumSplitQuantity){
                child.errorTips = child.childPlanQuantity !== child.sumSplitQuantity;
              }
            })
          }
        })
      },
      deep: true,
    },
  },
  methods: {
    querySupplier(purchasePlanId) {
      let productList = [];
      this.rows.forEach(item => {
        productList.push({
          productType: item.productType, sku: item.sku
        })
      })
      purchasePlanQuerySupplier({skuProductTypeList: productList}).then(res => {
        if (purchasePlanId) {
          this.bindSupplier(res, purchasePlanId)
        }else {
          this.bindSupplier(res, purchasePlanId, true)
        }
      })
    },
    bindSupplier(res, purchasePlanId, boo){
      this.tableData.forEach(item => {
        res.forEach(v => {
          v.supplierInfoVOList.forEach(sup => {
            sup.id = sup.supplierCode;
            sup.text = sup.supplierName;
            sup.splitOrderQuantity = sup.splitOrderQuantity || null;
            sup.disabled = false;
          })
          item.childProductVOList.forEach(child => {
            if(child.purchasePlanId === purchasePlanId || boo){
              if (item.purchaseType === 'single') {
                if (v.sku === item.sku) {
                  let find = v.supplierInfoVOList.find(vo => vo.supplierCode ===  child.planSupplierInfoVOList[0].supplierCode);
                  find.planQuantity = null;
                  find.disabled = true;
                  if(v.supplierInfoVOList.length === 1){
                    this.tableData.forEach(tb => {
                      if(tb.purchasePlanId === child.purchasePlanId){
                        find.splitOrderQuantity = tb.planQuantity;
                      }
                    })
                  }
                  this.$set(child, "supplierInfoVOList", this._.cloneDeep(v.supplierInfoVOList));
                  this.$set(child,'planSupplierInfoVOList',[this._.cloneDeep(find)]);
                }
              } else {
                if (v.sku === child.sku) {
                  let find = v.supplierInfoVOList.find(vo => vo.supplierCode ===  child.planSupplierInfoVOList[0].supplierCode);
                  find.planQuantity = null;
                  find.disabled = true;
                  if(v.supplierInfoVOList.length === 1){
                    find.splitOrderQuantity = child.childPlanQuantity;
                  }
                  this.$set(child, "supplierInfoVOList", this._.cloneDeep(v.supplierInfoVOList))
                  this.$set(child,'planSupplierInfoVOList',[this._.cloneDeep(find)]);
                }
              }
            }
          })
        })
      })
    },
    changePurchaseType(val, rows) {
      rows.childProductVOList = [];
      this.loading.content = true;
      this.$gjQuery([rows], val, 'one');
    },
    $gjQuery(rows = [], purchaseType, type = 'all') {
      purchasePlanSplitOrder({
        ids: rows.length > 0 ? rows.map(i => i.purchasePlanId) : this.rows.map(i => i.purchasePlanId),
        purchaseType: purchaseType
      }).then(res => {
        res.forEach(item => {
          item.sumSingleQuantity = null;
          item.errorTips = false;
          item.childProductVOList.forEach(child => {
            child.purchasePlanId = item.purchasePlanId;
            child.errorTips = false;
            child.planSupplierInfoVOList.forEach(sup => {
              sup.splitOrderQuantity = null;
              sup.purchasePlanId = child.purchasePlanId;
            })
          })
        })
        if (type === 'all') {
          this.tableData = res;
        } else {
          let find = this.tableData.findIndex(v => v.sku === res[0].sku && v.purchasePlanId === res[0].purchasePlanId);
          this.tableData.splice(find, 1, res[0]);
        }
        if(type === 'one'){
          this.querySupplier(res[0].purchasePlanId);
        }else{
          this.querySupplier(null);
        }
      }).catch(() => {
        this.$gjDestroy();
      }).complete(() => {
        this.loading.content = false;
      })
    },
    listToData() {
      let generateList = [];
      this.tableData.forEach(item => {
        if (item.purchaseType === 'single') {
          let obj = this._.cloneDeep(item);
          if(obj.childProductVOList){
            delete obj.childProductVOList;
          }
          obj.deliveryWarehouseId = item.deliveryWarehouseId;
          obj.demandQuantity = item.planQuantity;
          obj.splitOrderQuantity = item.sumSingleQuantity;
          obj.supplierInfoVOList = item.childProductVOList[0].planSupplierInfoVOList;
          generateList.push(obj);
        } else {
          item.childProductVOList.forEach(child => {
            let obj = {};
            obj.assembly = item.assembly;
            obj.deliveryWarehouseId = item.deliveryWarehouseId;
            obj.planDeliveryDate = item.planDeliveryDate;
            obj.productType = item.productType;
            obj.purchasePlanCode = item.purchasePlanCode;
            obj.purchasePlanId = item.purchasePlanId;
            obj.purchaseType = item.purchaseType;
            obj.urgent = item.urgent;
            obj.demandQuantity = child.childPlanQuantity;
            obj.splitOrderQuantity = child.sumSplitQuantity;
            obj.sku = child.sku;
            obj.supplierInfoVOList = child.planSupplierInfoVOList;
            generateList.push(obj);
          })
        }
      })
      // 清空 绑定的供应商列表，防止出现循环引用
      generateList.forEach(item=>{
        item.supplierInfoVOList.forEach(sup=>{
          if(sup.supplierInfoVOList) sup.supplierInfoVOList = null;
          if(sup.planSupplierInfoVOList) sup.planSupplierInfoVOList = null
        })
      })
      return generateList;
    },
    subOrder() {
      if (this.tableData.length === 0) {
        this.$gjMessage.error("没有可生成的数据！")
        return false;
      }
      this.openValid = true;
      this.$nextTick(()=>{
        if (this.formValidate()) {
          if (this.checkOrder(this.listToData())) return;
          this.loading.subOrder = true;
          purchasePlanGenerateOrder({generateList:this.listToData()}).then(() => {
          }).then(() => {
            this.$gjMessage.success('操作成功');
            this.$emit('updated');
            this.$gjDestroy();
          }).complete(() => {
            this.loading.subOrder = false;
          })
        } else {
          this.$gjMessage.error("请填写完整！");
        }
      })
    },
    formValidate() {
      let flagArr = [];
      flagArr = this.$refs.orderTable.map(item=>{
        return item.formValidate()
      })
      return !flagArr.includes(false);
    },
    checkOrder(listData) {
      let messageError = "";
      let flag = false;
      listData.forEach(item => {
        if (item.splitOrderQuantity !== item.demandQuantity) {
          messageError += `【${item.sku}】的分单量和需求量不相等，`;
          flag = true;
        }
      });
      listData.forEach(item => {
        item.supplierInfoVOList.forEach(sup =>{
          if(sup.splitOrderQuantity < sup.moq){
            messageError += `【${sup.sku}】最小起订量不符，`;
            flag = true;
          }
        })
      })
      if (flag) {
        this.$gjMessage.error(messageError);
      }else{
        let checkSupper = [];
        listData.forEach(item => {
          item.supplierInfoVOList.forEach(sup => {
            checkSupper.push({skuSupplierCode: item.sku + sup.supplierCode, includeTaxPrice: sup.includeTaxPrice})
          })
        })
        let checkSupperObj = checkSupper.reduce((obj, item) => {
          obj[item.skuSupplierCode] ? obj[item.skuSupplierCode].push(item.includeTaxPrice) : obj[item.skuSupplierCode] = [item.includeTaxPrice]
          return obj
        }, {})
        for (const key in checkSupperObj) {
          if (checkSupperObj[key].length > 1) {
            let sign = [...new Set(checkSupperObj[key])]
            if (sign.length > 1) {
              this.$gjMessage.error("存在同一产品供应商相同，SKU含税单价不一致，请检查并修正");
              return true;
            }
          }
        }
      }
      return flag;
    },
  },
}
</script>

<style scoped lang="scss">
.info-box-out{
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: space-between;
  background-color:#EFF1F4;

  .radio-box{
    flex: none;
    padding-right: 30px;

  }
}

.info-box{
  height: 40px;
  padding: 0 20px 0 24px;
  background-color:#F6F8FB;
  display: flex;
  flex-wrap:wrap;
  position: relative;
  font-size: 12px;
  color: #999999;
  font-weight: 400;
  border-bottom: 1px solid #e8eaec;
  .gj-label-str{
    margin-right: 15px;
  }
  .gj-label-img{
    width: 40px;
    height:40px;
    margin-right: 8px;
    position: relative;
  }
  /deep/.el-radio{
    height: 16px;
    margin-right: 0;
  }
  /deep/.el-radio+.el-radio{
    margin-left: 15px;
  }
}

.table-content {
  border: 1px solid #e8eaec;
}

.table-content {
  margin-top: 20px;
}

.m-top {
  margin-top: 0;
}

.ellipsis{
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.gj-tag {
  display: inline-block;
  position: absolute;
  top: -1px;
  left: -1px;
  background: #F25555;
  width: 20px;
  height: 20px;
  border-radius: 2px;
  font-size: 12px;
  color: #FFFFFF;
  line-height: 20px;
  text-align: center;
  font-weight: 500;
}

.gj-text {
  color: #333333;
}

/deep/.vxe-table{
  border: none;
  .vxe-header--row{
    background-color: #FFFFFF;
  }
}
/deep/ .table-content{
  border-bottom: none;
}
.error-tips{
  color: red !important;
}
.loading-wrapper{
  position: absolute;top: 0;left: 0;height: 100%;width: 100%;z-index: 99;opacity: 0.8;
}
</style>
